module.exports = __webpack_public_path__ + "static/media/Reset_Light Blue.aafdd58e.svg";